import Vue from "vue";
import Router from "vue-router";
import Layout from "../components/layout/Layout";
// http://fontawesome.dashgame.com/

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  // 默认
  {
    path: "/",
    component: Layout,
    redirect: "/product/index",
    name: "Dashboard",
    hidden: true
    // children: [
    //   {
    //     path: "dashboard",
    //     component: () => import("@/views/dashboard/index")
    //   }
    // ]
  },
  {
    path: "/banner",
    component: Layout,
    meta: { title: "首页轮播", icon: "fa-home", guard: "1" },
    children: [
      {
        path: "index",
        name: "Form",
        component: () => import("@/views/banner/index"),
        meta: { title: "首页轮播", icon: "fa-picture-o ", guard: "1" }
      }
    ]
  },
  {
    path: "/client",
    component: Layout,
    meta: { title: "客户信息", icon: "fa-home", guard: "1" },
    children: [
      {
        path: "index",
        name: "Form",
        component: () => import("@/views/clients/index"),
        meta: { title: "客户信息", icon: "fa-users ", guard: "1" }
      }
    ]
  },
  {
    path: "/webInfo",
    component: Layout,
    meta: { title: "网站信息", icon: "fa-home", guard: "1" },
    children: [
      {
        path: "index",
        name: "webInfo",
        component: () => import("@/views/web/index"),
        meta: { title: "网站信息", icon: "fa-wrench ", guard: "1" }
      }
    ]
  },
  {
    path: "/product",
    component: Layout,
    children: [
      {
        path: "index",
        name: "product",
        component: () => import("@/views/product/index"),
        meta: { title: "产品管理", icon: "fa-cart-plus ", guard: "1" }
      }
    ]
  },
  {
    path: "/pcate",
    component: Layout,
    meta: { title: "产品分类", icon: "fa-home", guard: "1" },
    children: [
      {
        path: "index",
        name: "pcate",
        component: () => import("@/views/productCate/index"),
        meta: { title: "产品分类", icon: "fa-tags ", guard: "1" }
      }
    ]
  },
  {
    path: "/pparam",
    component: Layout,
    meta: { title: "产品基本属性", icon: "fa-home", guard: "1" },
    children: [
      {
        path: "index",
        name: "pcate",
        component: () => import("@/views/productParam/index"),
        meta: { title: "产品基本属性", icon: "fa-tags ", guard: "1" }
      }
    ]
  },
  {
    path: "/ppackage",
    component: Layout,
    meta: { title: "产品包装属性", icon: "fa-home", guard: "1" },
    children: [
      {
        path: "index",
        name: "ppackage",
        component: () => import("@/views/productPkg/index"),
        meta: { title: "产品包装属性", icon: "fa-tags ", guard: "1" }
      }
    ]
  },
  {
    path: "/news",
    component: Layout,
    meta: { title: "新闻信息", icon: "fa-home", guard: "1" },
    children: [
      {
        path: "index",
        name: "news",
        component: () => import("@/views/news/index"),
        meta: { title: "新闻信息", icon: "fa-newspaper-o ", guard: "1" }
      }
    ]
  },
  // {
  //   path: "/info",
  //   component: Layout,
  //   meta: { title: "系统属性", icon: "fa-home", guard: "1" },
  //   children: [
  //     {
  //       path: "index",
  //       name: "info",
  //       component: () => import("@/views/form/index"),
  //       meta: { title: "系统属性", icon: "fa-terminal", guard: "1" }
  //     }
  //   ]
  // },
  { path: "*", redirect: "/404", hidden: true }
];

export default new Router({
  // mode: "history", //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});
